import { render, staticRenderFns } from "./SubList.vue?vue&type=template&id=15f560e2&scoped=true&"
import script from "./SubList.vue?vue&type=script&lang=js&"
export * from "./SubList.vue?vue&type=script&lang=js&"
import style0 from "./SubList.vue?vue&type=style&index=0&id=15f560e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f560e2",
  null
  
)

export default component.exports